/*
 * Author: Blue Lobster Private Limited
 * Copyright: Blue Lobster Private Limited
 */
import { createRoot } from "react-dom/client";
import "./setup/disableConsoleLogs";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

import "./assets/scss/main.scss";

createRoot(document.getElementById("root")).render(
	// <React.StrictMode>
	<HelmetProvider>
		<App />
	</HelmetProvider>,
	// </React.StrictMode>,
);
